import React from 'react';
function Info({ size, stroke = 'currentColor', strokeWidth, ...otherProps }) {
  // @ts-ignore TS(2362): The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
  const correctedStrokeWidth = (strokeWidth - 1).toFixed(2);

  return (
    /**
     * Manual changes:
     * Value of attribute `fill` was change to `currentColor`, for covering proper color setup.
     * Property `strokeWidth` used for correct setup of icon size.
     * */
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        fill="currentColor"
        d="M13.88 15.92l-.127.572c-.38.165-.682.291-.908.378-.226.087-.489.13-.788.13-.46 0-.817-.124-1.071-.371a1.259 1.259 0 01-.383-.943c0-.148.01-.3.03-.454.018-.155.049-.33.091-.524l.471-1.854c.043-.178.078-.346.107-.505.029-.159.043-.303.043-.435 0-.237-.044-.402-.132-.495-.088-.093-.257-.14-.506-.14-.123 0-.248.021-.377.064a4.81 4.81 0 00-.33.12l.126-.57c.31-.14.608-.26.891-.36.284-.1.552-.149.805-.149.456 0 .807.122 1.054.365.248.244.371.56.371.95 0 .08-.008.222-.026.425-.017.203-.049.39-.095.558l-.47 1.848a5.622 5.622 0 00-.104.508c-.03.19-.046.335-.046.432 0 .245.05.412.15.502.099.088.271.133.516.133.115 0 .246-.023.391-.067.146-.044.251-.084.316-.117zM14 8.169c0 .322-.11.596-.33.822a1.07 1.07 0 01-.796.34 1.08 1.08 0 01-.8-.34 1.13 1.13 0 01-.333-.822c0-.321.111-.597.334-.825.222-.229.488-.343.799-.343.31 0 .575.114.795.343.22.228.331.504.331.825z"
        strokeWidth={correctedStrokeWidth}
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 4.212a7.788 7.788 0 100 15.576 7.788 7.788 0 000-15.576zM3 12a9 9 0 1118 0 9 9 0 01-18 0z"
        clipRule="evenodd"
        strokeWidth={correctedStrokeWidth}
      />
    </svg>
  );
}

export default Info;
